import { Box, Typography } from '@mui/material'
import { CardBigNumberTypography } from '@/components'
import { styled } from '@mui/material/styles'

const CardBigNumberLegendTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey['700'],
  width: '40%',
  leadingTrim: 'both',
  textEdge: 'cap',
  fontFamily: 'Geist Mono',
  fontSize: theme.typography.pxToRem(12),
  fontStyle: 'normal',
  fontWeight: 300,
  lineHeight: theme.typography.pxToRem(14)
}))

export interface CardBigNumberProps {
  value: number
  legend?: string
}

export function CardBigNumber({ value, legend }: CardBigNumberProps) {
  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'flex-end',
        gap: 2,
        mb: 1
      }}
    >
      <CardBigNumberTypography color="primary">{value}</CardBigNumberTypography>

      {legend ? (
        <CardBigNumberLegendTypography sx={{ mb: 1 }}>
          {legend}
        </CardBigNumberLegendTypography>
      ) : (
        ''
      )}
    </Box>
  )
}
